import React from 'react';
import { buildSchedule, WEEKDAYS } from '../utils/schedule';

// Which parts, how many a day, from when, on which weekdays, with a live preview of the resulting plan.
// value: { from, to, perDay, date, days }. onChange gets just the fields that changed.
export default function SchedulePicker({ idPrefix, parts, value, onChange }) {
  const { from, to, perDay, date, days } = value;
  const options = Array.from({ length: parts }, (_, i) => i + 1);
  const schedule = buildSchedule({ from, to, perDay, days, startDate: date });
  const toggleDay = (d) => onChange({ days: days.includes(d) ? days.filter(x => x !== d) : [...days, d] });

  return (
    <div className="sched">
      <div className="sched-fields">
        <div>
          <label htmlFor={`${idPrefix}-from`}>From part</label>
          <select id={`${idPrefix}-from`} value={from}
                  onChange={e => onChange(Number(e.target.value) > Number(to) ? { from: e.target.value, to: e.target.value } : { from: e.target.value })}>
            {options.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor={`${idPrefix}-to`}>to part</label>
          <select id={`${idPrefix}-to`} value={to} onChange={e => onChange({ to: e.target.value })}>
            {options.filter(n => n >= Number(from)).map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor={`${idPrefix}-per`}>Parts per day</label>
          <select id={`${idPrefix}-per`} value={perDay} onChange={e => onChange({ perDay: e.target.value })}>
            {[1, 2, 3, 4, 5].map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div>
          <label htmlFor={`${idPrefix}-date`}>Start date</label>
          <input id={`${idPrefix}-date`} type="date" required value={date} onChange={e => onChange({ date: e.target.value })} />
        </div>
      </div>
      <fieldset className="sched-days">
        <legend>Days of the week</legend>
        {WEEKDAYS.map((name, d) => (
          <label key={d} className="sched-day">
            <input type="checkbox" checked={days.includes(d)} onChange={() => toggleDay(d)} /> {name}
          </label>
        ))}
      </fieldset>
      {days.length === 0 && <div className="video-error" role="alert">Pick at least one day of the week.</div>}
      {schedule.length > 0 && (
        <div className="video-meta sched-preview" aria-live="polite">
          <strong>{schedule.length} assignment{schedule.length === 1 ? '' : 's'} per student:</strong>
          <ul>
            {schedule.map(it => (
              <li key={it.part_from}>
                {it.part_from === it.part_to ? `Part ${it.part_from}` : `Parts ${it.part_from}–${it.part_to}`}
                {' · '}{new Date(`${it.assigned_date}T12:00:00`).toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' })}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
